import * as React from "react";

import API from "../../vendor/api";
import * as moment from "moment";

const s = require("./message.scss");

interface IMessageProps {
    message: API.Message;
    mine: boolean;
};

interface IMessageState {};

class Message extends React.Component<IMessageProps, IMessageState> {
    public render(): JSX.Element {
        const message = this.props.message;
        const mine = this.props.mine;

        const messageContent = () => {
            switch (message.type) {
                case API.MessageType.MetaMemberJoined:
                    return message.user.name + " entrou na conversa";
                case API.MessageType.MetaMemberInvited:
                    return message.user.name + " foi convidado para a conversa";
                case API.MessageType.Text:
                    return message.text;
                case API.MessageType.Image:
                    return <img src={message.image.small_url} />
            }
        };

        
        const time = moment(message.time).format("HH:ss");

        switch (message.type) {
                case API.MessageType.MetaMemberJoined:
                case API.MessageType.MetaMemberInvited:
                    return (
                        <li className={s.meta}>
                            <span>{messageContent()}</span>
                        </li>
                    )
                case API.MessageType.Text:
                case API.MessageType.Image:
                    return (
                        <li className={s.message + (mine ? " " + s.mine : "")}>
                            {messageContent()}
                            <span className={s.time}>{time}</span>
                            <span className={s.status}>
                                <i className="fa fa-check" aria-hidden="true"></i>
                                {(message.status === API.MessageStatus.ReadByAll ? (
                                    <i className="fa fa-check" aria-hidden="true"></i>                    
                                ) : null)}
                            </span>
                        </li>
                    );
                default:
                    return null;
                    /*return (
                        <li className={s.meta}>
                            <span>Mensagem desconhecida</span>
                        </li>
                    );*/
            }
        
    }
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/Message/index.tsx